exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leaflet-cluster-anim .leaflet-marker-icon, .leaflet-cluster-anim .leaflet-marker-shadow {\r\n\ttransition: transform 0.3s ease-out, opacity 0.3s ease-in;\r\n}\r\n\r\n.leaflet-cluster-spider-leg {\r\n\t/* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */\r\n\ttransition: stroke-dashoffset 0.3s ease-out, stroke-opacity 0.3s ease-in;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /app/SPA/~/css-loader?{"sourceMap":false,"importLoaders":1}!/app/SPA/~/postcss-loader?{"ident":"postcss"}!/app/SPA/~/leaflet.markercluster/dist/MarkerCluster.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../leaflet.markercluster/dist/MarkerCluster.css
// module chunks = 2